import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/Green.module.styl'
import tree from '~/assets/img/Arvore.png'
import bg from '~/assets/img/folhagem-verde.webp'
import { useLanguage } from '~/hooks'

export default function Green() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <h2>
        <span>
          {t('Green.green')}
          <br />
          {t('Green.overflowing')}
        </span>
      </h2>
      <Lazyload src={tree} className={st.tree} />
      <Lazyload src={bg} className={st.bg} />
      <div>
        <p>{t('Green.bioPhilicDesign')}</p>
      </div>
    </section>
  )
}
